<template>
  <main-content>
    <template v-slot:left>
      <i class="fas fa-hard-hat mr-3"></i>
      {{pageTitle}}
    </template>
    <template v-slot:right></template>
    <div class="col-12 col-lg-11">
      <div class="card-body ">
        <div class="row">
          <div class="col-12 col-md-4 mb-2">
                    <b-form-select  
                    id="form_edit_weight" 
                    v-model="playlistId" 
                    :options="playlistOptions"
                    ></b-form-select>
          </div>
        </div>
        <file-upload @relist="onTriggerRelist" :playlistId="playlistId"></file-upload>
        <media-toolbar 
        ref="toolbar" 
        :selectedItems="selectedItems" 
        @relist="onTriggerRelist"
        @playlistEvent="onPlaylistEvent"
        >
        </media-toolbar>
      </div>

      <Datatable
        ref="datatable"
        :fetchData="getData"
        :columns="columns"
        :tableTitle="pageTitle"
        :tableClasses="['table-bordered', 'table-hover', 'text-nowrap']"
      >
        <template v-slot:table-head>
          <!-- {{columns[0]}} -->
          <th style="padding-bottom: 20px;">
            <label class="icheck">
              <input id="select_all" v-model="selectAll" type="checkbox" />
              <span class="checkmark"></span>
            </label>
          </th>
          <th width="50px">Cover</th>
          <th>Name</th>
          <th>Action</th>
        </template>
        <template v-slot:table-body="data">
          
          <tr v-if="Object.keys(data).length==0" class="odd">
            <td valign="top" colspan="9" class="text-center dataTables_empty">No media file uploaded yet</td>
          </tr>

          <tr v-for="media_file in data" :key="media_file.id">
            <td>
              <label class="icheck">
                <input
                  :id="media_file.id"
                  type="checkbox"
                  :value="media_file"
                  v-model="selectedItems"
                />
                <span class="checkmark"></span>
              </label>
            </td>

            <td>
              <img
                id="picture"
                :src="getImg(media_file.art)"
                width="100%"
                height="auto"
                :alt="media_file.title"
              />
            </td>
            <td>
              {{media_file.title}}
              <br />
              <small>created {{media_file.created_at | moment_fromNow}}</small>
              <br />
              <small>Length: {{media_file.length_text}}</small> |
              <small>Size: {{size2Byte(media_file.size)}}</small>
              <br />
              <small
                v-show="media_file.playlists.length >0"
              >Playlists: {{joinPlalist(media_file.playlists)}}</small>
              <br />
            </td>
            <td>
              <a
                class="btn btn-info btn-sm"
                 href="#"
                @click.prevent="doEdit( media_file)"
              >Edit</a>
            </td>
          </tr>
        </template>

        <template v-slot:header></template>
      </Datatable>
       <edit-modal
        ref="editModal"
        @relist="onTriggerRelist"
      ></edit-modal>
    </div>
  </main-content>
</template>

<script>
import Datatable from "@/components/datatable/Datatable.vue";
import MediaToolbar from "@/pages/media/components/MediaToolbar";
import FileUpload from "@/pages/media/components/MediaFileUpload";
import EditModal from "./EditModal.vue";
import { size2Byte } from "@/plugins/utils";
import { FETCH_MEDIA_FILES, FETCH_STATION_INFO } from "@/store/action-types";
import { mapState } from 'vuex';

export default {
  components: {
    Datatable,
    FileUpload,
    MediaToolbar,
    EditModal
  },

  computed:{
    ...mapState({
        files:(state) => state.media.data
    }),

     selectAll: {
            get: function () {
                return this.files ? this.selectedItems.length == this.files.length : false;
            },
            set: function (value) {
                let selected = [];

                if (value) {
                    this.files.forEach(function (item) {
                        selected.push(item);
                    });
                }

                this.selectedItems = selected;
            }
        }

  },
  

  methods: {
    size2Byte,

    getImg(url) {
      return url || require("@/assets/logo.svg");
    },
    getData(data){
          return this.$store.dispatch(FETCH_MEDIA_FILES, data)
    },
    
    doCreate() {
      this.$refs.editModal.create();
    },


    joinPlalist(playlists) {
      return _.map(playlists, (item) => item.name).join(", ");
    },

    doEdit(file) {
      this.$refs.editModal.open(file);
    },

    onTriggerRelist() {
      this.selectedItems = [];
      this.$refs.datatable.getData();
      this.$refs.toolbar.getData();
      // Refresh station info to update is_playable status
      this.$store.dispatch(FETCH_STATION_INFO, {
        id: this.stationId,
        repeat: false
      });
    },

    onPlaylistEvent(playlists) {

      const playlistOptions =  _.map(playlists, (item) =>{
          return {"value": item.id, "text": item.name}
       } );

       this.playlistOptions.push(...playlistOptions)

    },
  },

  data() {
    return {
      pageTitle: "Media Files",
      url: "/admin/files",
      selectedItems: [],
      playlistId: null,
      playlistOptions:[
        { value: null, text: 'Select Playlist (optional)' }
      ],
      columns: [
        { label: "Count" },
        { label: "Cover", width: "50px" },
        { label: "Name" },
        { label: "Action" },
      ],
    };
  },
};
</script>


<style scoped>
</style>
